$(document).ready(function(){

  //newsletter accordion
  $(document).on("click", ".newsletter_accordion_section .accordion_heading", function() {
     $(this).toggleClass("active").next().slideToggle();
   });

  $('.site-navigation ul li a.custom-link').on('click', function(){
    if(!$(this).hasClass('has_cust')){
      $(".custom-model-main").addClass('model-open');
      $("body").addClass('login-model-open');
    }
  });
  
  $('.mobile-nav-content .navmenu-item a.custom-link').on('click', function(){
    if(!$(this).hasClass('has_cust')){
      $(".custom-model-main").addClass('model-open');
      $("body").addClass('login-model-open');
    }
  });
  
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $("body").removeClass('login-model-open');
  });

  if($('body').hasClass('template-login')){
    var url = window.location.href;
     if(url.includes('#customer_recovery')){
       $('.account-recovery').addClass('visible');
       $('.account-login').removeClass('visible');
     }
  }
  
  //for collection page
  $(document).on(
    "click",
    ".modal-content .filter-form .collection-filters__filter-group ul li [data-filter-input]",
    function () {
      if ($(this).find("svg").attr("data-animation-state") == "checked") {
        $(this)
          .find("svg path.checkmark__check")
          .attr("data-animation-state", "unchecked");
        $(this).removeAttr("data-filter-active");
        $(this).find("svg").attr("data-animation-state", "unchecked");
      } else {
        $(this)
          .find("svg path.checkmark__check")
          .attr("data-animation-state", "checked");
        $(this).attr("data-filter-active");
        $(this).find("svg").attr("data-animation-state", "checked");
      }
    }
  );

  $(document).on("click", ".filter-btn .apply-filter", function () {
    var url_of_btn = $(this).attr("data-url");
    if (url_of_btn.includes("?")) {
      var url_of_btn_0 = url_of_btn.split("?")[0];
      var url_of_btn_1 = url_of_btn.split("?")[1];
    } else {
      var url_of_btn_0 = url_of_btn;
    }
    var tag_active_legnth = $(
      ".modal-content .filter-form .collection-filters__filter-group ul li a[data-filter-active]"
    ).length;
    if (tag_active_legnth > 0) {
      for (var i = 0; i < tag_active_legnth; i++) {
        var name = $(
          ".modal-content .filter-form .collection-filters__filter-group ul li a[data-filter-active]"
        )
          .eq(i)
          .attr("data-name");
        var value = $(
          ".modal-content .filter-form .collection-filters__filter-group ul li a[data-filter-active]"
        )
          .eq(i)
          .attr("data-value");
        var value = encodeURIComponent(value).replace("'", "%27");
        value = value.replace(/\%20+/g, "+");
        console.log(value);
        if (url_of_btn_0.includes("?")) {
          var url_of_btn_0 = url_of_btn_0 + "&" + name + "=" + value;
        } else {
          var url_of_btn_0 = url_of_btn_0 + "?" + name + "=" + value;
        }
      }
      if (url_of_btn_1) {
        var url_of_btn_0 = url_of_btn_0 + "&" + url_of_btn_1;
      }
      window.location.href = url_of_btn_0;
    } else {
      $(".modal-close").trigger("click");
    }
  });

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  //newsletter-popup
  var url = window.location.href;
  var myCookie = getCookie("Modal Newsletter");
  if (myCookie) {
    if (url.includes("customer_posted=true#contact_form")) {
      if ($(".cstm-newsletter").is(":visible")) {
        if (myCookie == "Submitted") {
          $(".cstm-newsletter").hide();
        }
      }
    } else {
      $(".cstm-newsletter").hide();
    }
  } else {
    $(".cstm-newsletter").show();
  }

  $(document).on("click", ".cstm-newsletter .form-close", function () {
    if (
      $(".cstm-newsletter .cstm-newsletter-form .popup-newsletter.active")
        .length > 0
    ) {
      setCookie("Modal Newsletter", "Submitted");
      $(".cstm-newsletter").hide();
    } else {
      setCookie("Modal Newsletter", "Not Submit Only Closed");
      $(".cstm-newsletter").hide();
    }
  });

  if (document.body.clientWidth < 1023) {
    $(".site-footer-block-newsletter").insertAfter(".site-footer-social");
  }

  if ($("body").hasClass("template-register")) {
    $("button.form-action--submit").on("click", function () {
      $(".form-message.message--error").remove();
      var email = $("#register_email").val();
      var pass = $("#register_password").val();
      var conf_pass = $("#register_confirm_password").val();
      var npi_val = $("#register_npi_number").val();
      var agree = $("#register_accept_agreement").is(":checked");
      
      if(!email){
        $("#register_email").addClass("form-field-error");
        if ($(".form-message.message--error ul li.email").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html = "<li class='email'>Email can't be blank.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html =
              "<div class='account-message form-message message--error'><div class='errors'><ul><li class='email'>Email can't be blank.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      } else if (!pass) {
        $("#register_password").addClass("form-field-error");
        if ($(".form-message.message--error ul li.pass").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html = "<li class='pass'>Password can't be blank.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='pass'>Password can't be blank.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      } else if (!conf_pass) {
        $("#register_confirm_password").addClass("form-field-error");
        if ($(".form-message.message--error ul li.regi_pass").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html =
              "<li class='regi_pass'>Confirm password can’t be blank.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html = "<div class='account-message form-message message--error'><div class='errors'><ul><li class='regi_pass'>Confirm password can’t be blank.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      } else if (conf_pass != pass) {
        $("#register_confirm_password").addClass("form-field-error");
        if ($(".form-message.message--error ul li.regi_pass").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html =
              "<li class='regi_pass'>Your passwords do not match. Please ensure the Password and Confirm Password field values match.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html =
              "<div class='account-message form-message message--error'><div class='errors'><ul><li class='regi_pass'>Your passwords do not match. Please ensure the Password and Confirm Password field values match.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      } else if (npi_val && npi_val.length < 10) {
        $("#register_npi_number").addClass("form-field-error");
        if ($(".form-message.message--error ul li.npi").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html =
              "<li class='npi'>Please enter a valid NPI number. The NPI is a 10-digit identifier. To look up your NPI number, visit <a href='https://npiregistry.cms.hhs.gov/search' style='text-decoration:underline' >here</a>.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html =
              "<div class='account-message form-message message--error'><div class='errors'><ul><li class='npi'>Please enter a valid NPI number. The NPI is a 10-digit identifier. To look up your NPI number, visit <a style='text-decoration:underline' href='https://npiregistry.cms.hhs.gov/search'>here</a>.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      } else if (!agree) {
        if ($(".form-message.message--error ul li.accept_agree").length < 1) {
          if ($(".form-message.message--error").length > 0) {
            var html =
              "<li class='accept_agree'>Please read and accept the PedsMarket Agreement.</li>";
            $(html).insertAfter(".form-message.message--error ul li:last");
          } else {
            var html =
              "<div class='account-message form-message message--error'><div class='errors'><ul><li class='accept_agree'>Please read and accept the PedsMarket Agreement.</li></ul></div></div>";
            $(html).insertBefore(".form-fields-columns");
          }
        }
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      }
    });
  }

  if ($("body").hasClass("template-login")) {
    var url = window.location.href;
    console.log(url);
    if (url.includes("#recover")) {
      if (!$("div.account-recovery").is(":visible")) {
        console.log("recover");
        $("a[data-login-toggle]").trigger("click");
      }
    }
  }

  if ($("body").hasClass("template-account")) {
    $(document).find("a.edit_details").on("click", function () {
        $(".cstm-acc-inner").css("display", "none");
        $(".cstm-edit-form").css("display", "block");
    });
    $(document).find("a.cancel_edit").on("click", function () {
        $(".cstm-acc-inner").css("display", "flex");
        $(".cstm-edit-form").css("display", "none");
        $(".success-msg").css("display", "none");
    });
  }

  $(document).on(
    "mouseenter",
    ".template-search .productgrid--wrapper ul li",
    function () {
      $(this).find(".productitem").removeAttr("data-animation-state");
      $(this).find(".productitem").removeAttr("data-animation");
      $(this).css({ "--open-height": "0px" });
    }
  );

  $(document).on(
    "mouseenter",
    ".product-recently-viewed__wrapper ul li.has_atc_button",
    function () {
      var get_height = $(this).height();
      var action_height = $(this).find(".productitem--actions").height();
      var heightexpanded = get_height + action_height;
      var flickity_height = $(this).parents(".flickity-viewport").height();
      var item_height = $(this).find(".productitem").height();

      $(".product-recently-viewed__wrapper ul li").css("--base-height", "");
      $(".product-recently-viewed__wrapper ul li").css(
        "--open-height",
        heightexpanded + "px"
      );
      $(".product-recently-viewed__wrapper ul li").css(
        "height",
        get_height + "px"
      );
      $(".product-recently-viewed__wrapper ul li").removeAttr("data-open");
      $(".product-recently-viewed__wrapper ul li")
        .find(".productitem--actions")
        .css({ visibility: "hidden", opacity: 0 });

      $(this).css("--base-height", get_height + "px");
      $(this).css("--open-height", heightexpanded + "px");
      $(this).css("height", heightexpanded + "px");
      $(this)
        .parents(".flickity-viewport")
        .css("height", heightexpanded + "px");
      $(this).attr("data-open", "");

      $(this)
        .find(".productitem--actions")
        .css({ visibility: "visible", opacity: 1 });

      $(this).mouseleave(function () {
        $(this)
          .parents(".flickity-viewport")
          .css("height", flickity_height + "px");
        $(this).css("--base-height", "");
        $(this).css("--open-height", heightexpanded + "px");
        $(this).css("height", get_height + "px");
        $(this).removeAttr("data-open");
        $(this)
          .find(".productitem--actions")
          .css({ visibility: "hidden", opacity: 0 });
      });
    }
  );

  //add to cart for recently view
  $(document).on(
    "click",
    ".product-recently-viewed__wrapper ul li .productitem--actions button[data-quick-buy]",
    function () {
      $(this).find(".atc-button--text").css("opacity", 0);
      $(this)
        .find(".atc-button--icon")
        .css({ opacity: 1, visibility: "visible" });
      var variantID = $(this).attr("data-variant-id");
      if (variantID) {
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + 1 + "&id=" + variantID,
          dataType: "json",
          success: function (line_item) {
            console.log("success");
            window.location.href = "/cart";
          },
          error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
            $(this).find(".atc-button--text").css("opacity", 1);
            $(this)
              .find(".atc-button--icon")
              .css({ opacity: 0, visibility: "hidden" });
          },
        };
        jQuery.ajax(params);
      } else {
        $(this).find(".atc-button--text").css("opacity", 1);
        $(this)
          .find(".atc-button--icon")
          .css({ opacity: 0, visibility: "hidden" });
      }
    }
  );

  $(".accordion").on("click", ".heading", function () {
    $(this).toggleClass("active").next().slideToggle();

    $(".contents").not($(this).next()).slideUp(300);

    $(this).siblings().removeClass("active");
  });

  //help faq Page video
  function playIframeVideo(iframe) {
    iframe.videoPlay = true; //init state
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      "*"
    );
  }

  function pauseIframeVideo(iframe) {
    iframe.videoPlay = false; //init state
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }
  $(document)
    .find(".custom-video-wrapper .cstm-video-around .custom-video-inner")
    .each(function () {
      $(this)
        .find(".video-wrapper .cstm-caption-img")
        .on("click", function (event) {
          event.preventDefault();
          $(this).hide();

          if ($(this).hasClass("youtube_type")) {
            // console.log('youtube');
            var iframe = $(this).siblings("iframe").get(0); //iframe tag
            if (iframe.videoPlay != true) {
              playIframeVideo(iframe);
            } else {
              pauseIframeVideo(iframe);
            }
          } else {
            // console.log('vimeo');
            $(this).siblings("iframe")[0].src += "&autoplay=1";
          }
        });
    });

  if ($("body").hasClass("help-center-faqs")) {
    $(".form-field-input").each(function () {
      var length = $(this).val();
      if (length) {
        $(this).addClass("form-field-filled");
      } else {
        $(this).removeClass("form-field-filled");
      }
    });
    $(".form-field-input").on("input", function () {
      var length = $(this).val();
      if (length) {
        $(this).addClass("form-field-filled");
      } else {
        $(this).removeClass("form-field-filled");
      }
    });
  }

  $(".chosen-select").chosen();

  //data prefences add link
  if (document.querySelector("svg#return")) {
    var anchor = document.createElement("a");
    anchor.href = "https://pedsmrkt.com/pages/cookie-policy";
    var svg = document.querySelector("svg#return");
    anchor.appendChild(svg);
    var hr_content = document.querySelector(".hulk_cookie_bar h2");
    var text = hr_content.textContent;
    var span = document.createElement('span');
    span.textContent = text;
    hr_content.textContent = '';
    hr_content.appendChild(span);
    hr_content.insertBefore(anchor, span);
  }
  
});